<template>
  <div class="model" v-if="this.isShowing" ref="draggableElement" :class="{ 'searched' : searched == true }" v-bind:style="{ background: this.background, animation: 'rotate '+this.rotationSpeed+'ms ease infinite', transform: this.rotation, top: 'calc('+(this.interactPosition.y+5)+'% - 1.5rem)', left: 'calc('+(this.interactPosition.x+5)+'% - 1.5rem)' }">
  </div>
</template>

<script>
import interact from "interact.js";

export default {
  name: 'Model',
  props: {
    background: String,
    searched: Boolean,
    rotationSpeed: Number,
    transformation: String
  },
  data(){
    return{
      interactPosition: {
        x: 0,
        y: 0
      },
      startPosition:{
        x: 0,
        y: 0
      },
      dimensions:{
        width: 0,
        height: 0
      },
      isShowing: true,
      rotation: this.transformation
    }
  },
  methods: {
    interactSetPosition(coordinates) {
      const { x = 0, y = 0 } = coordinates;
      this.interactPosition = { x, y };
    },
    resetPosition(){
      var x = this.startPosition.x;
      var y = this.startPosition.y;
      this.interactPosition = { x , y };
    }
    ,
    storeStartPosition(x, y){
      this.startPosition.x = x;
      this.startPosition.y = y;
    },
    changePositions(){
      var x;
      var y;
        if(this.rotation === null ){
          x = Math.floor(Math.random() * 85);
          y = Math.floor(Math.random() * 70);
        }
        else{
          x = Math.floor(Math.random() * 50)+15;
          y = Math.floor(Math.random() * 50)+15;
        }
        return { x, y };
    },

    dropModel() {
      this.hideModel();
    },
    interactUnsetElement() {
      interact(this.$refs.interactElement).unset();
      this.isInteractDragged = true;
    },
    hideModel() {
      setTimeout(() => {
        this.isShowing = false;
        this.$emit("excludeModel", this.$attrs.id, true);
      }, 300);
    }
  },
  created: function(){
    this.interactPosition = this.changePositions();
  },
  mounted(){
    const element = this.$refs.draggableElement;

    interact(element).draggable({
      onstart: () => {
        var startX = this.interactPosition.x;
        var startY = this.interactPosition.y;
        this.storeStartPosition( startX, startY );
      },
      onmove: event => {

        const x = this.interactPosition.x + (event.dx/document.getElementById('game').clientWidth)*100;
        const y = this.interactPosition.y + (event.dy/document.getElementById('game').clientHeight)*100;

        this.interactSetPosition({ x, y });
      },
      onend: () => {

        if( this.searched && ( this.interactPosition.x>=15 && this.interactPosition.x<=65 ) && ( this.interactPosition.y>=70 && this.interactPosition.y<=100 ) ){
          this.dropModel();
        }else if( (this.interactPosition.x >= 93 || this.interactPosition.y >= 93 || this.interactPosition.x <= 1 || this.interactPosition.y <= 1) || ((!this.searched) && ( this.interactPosition.x>=30 && this.interactPosition.x<=70 ) && ( this.interactPosition.y>=70 && this.interactPosition.y<=100 )) ){
          this.resetPosition();
        }

      }
    });


  }
}
</script>
